import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Query options for a panel that shows its own failure with LoadFailed, so the
 * rest of the page carries on: only a denial still reaches the error page.
 */
export const showsOwnFailure = {
  useErrorBoundary: (error: any) => error?.response?.status === 403,
};

/** Says a panel's data didn't load. */
const LoadFailed: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <p
      role="alert"
      className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
    >
      {t("zenith.ui.load_failed")}
    </p>
  );
};

export default LoadFailed;
